/**
 * IB product feature gates from MobileService `/v1/ib/accounts` (+ `/me`).
 * Instance feature Enabled=0 (or entity override) → hide product menus.
 * Missing payload → treat as enabled (backward compatible).
 *
 * Wallet `/cartoes` is gated separately from BaaS issuer `/baas/cartoes`:
 * instance `cards` still drives the issuer console; this flag hides the
 * end-user wallet card screens. Flip to `true` to show them again (instance
 * must also have `cards` enabled).
 */
export const WALLET_CARDS_UI_ENABLED = false;

export const DEFAULT_IB_PRODUCT_FEATURES = Object.freeze({
  pix: true,
  cards: true,
  stables: true,
  fiat: true,
  carteira: true,
});

export const normalizeIbProductFeatures = (raw) => {
  if (!raw || typeof raw !== "object") {
    return { ...DEFAULT_IB_PRODUCT_FEATURES };
  }

  return {
    pix: raw.pix !== false,
    cards: raw.cards !== false,
    stables: raw.stables !== false,
    fiat: raw.fiat !== false,
    carteira: raw.carteira !== false,
  };
};

/** @param {"pix"|"cards"|"stables"|"fiat"|"carteira"} code */
export const isIbProductEnabled = (features, code) => {
  if (!code) return true;
  if (code === "cards" && !WALLET_CARDS_UI_ENABLED) return false;
  const normalized = normalizeIbProductFeatures(features);
  return normalized[code] !== false;
};
